// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nVR0","newExpiryDate":"styles_newExpiryDate__1xl7i","footer":"styles_footer__O2aLm"};